(() => {
  const initFooterAccordions = (root = document) => {
    root.querySelectorAll('.bivalta-footer__menu').forEach((menu, index) => {
      if (menu.dataset.mobileAccordion === 'true') return;
      const heading = menu.querySelector('h2, h3');
      const list = menu.querySelector('ul');
      if (!heading || !list) return;

      const id = list.id || `BivaltaFooterMenu-${Date.now()}-${index}`;
      list.id = id;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bivalta-footer__menu-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', id);
      button.innerHTML = `<span>${heading.textContent.trim()}</span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

      heading.insertAdjacentElement('afterend', button);
      menu.classList.add('bivalta-footer__menu--enhanced');
      menu.dataset.mobileAccordion = 'true';

      button.addEventListener('click', () => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const open = !menu.classList.contains('is-open');
        menu.closest('.bivalta-footer__menus')?.querySelectorAll('.bivalta-footer__menu--enhanced.is-open').forEach((other) => {
          if (other !== menu) {
            other.classList.remove('is-open');
            other.querySelector('.bivalta-footer__menu-toggle')?.setAttribute('aria-expanded', 'false');
          }
        });
        menu.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  };

  const normalizeFooterForViewport = () => {
    if (window.matchMedia('(min-width: 750px)').matches) {
      document.querySelectorAll('.bivalta-footer__menu--enhanced.is-open').forEach((menu) => menu.classList.remove('is-open'));
      document.querySelectorAll('.bivalta-footer__menu-toggle').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    }
  };

  const init = (root = document) => {
    initFooterAccordions(root);
    normalizeFooterForViewport();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(normalizeFooterForViewport, 100);
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
